import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  columnBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: theme.spacing(1),
  },
  headerBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
}))

export default styles
